import { render, staticRenderFns } from "./Administrationsettings.vue?vue&type=template&id=634cd988&scoped=true"
import script from "./Administrationsettings.vue?vue&type=script&lang=js"
export * from "./Administrationsettings.vue?vue&type=script&lang=js"
import style0 from "./Administrationsettings.vue?vue&type=style&index=0&id=634cd988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634cd988",
  null
  
)

export default component.exports